import { Link } from "react-router-dom";

const SlotCard = ({ slot }) => (
  <div className="slot-card">
    <Link to={`/slot/${slot.id}`}>
      <img src={slot.imageUrl} alt={slot.name} />
    </Link>
    <h2>{slot.name}</h2>
    <p>{slot.manufacturer}</p>
    <a href={`http://www.x.com/${slot.account}`} target="_blank">
      <img src="/images/x.png" class="x-account" />
    </a>
    <Link to={`/slot/${slot.id}`}>詳細を見る</Link>
  </div>
);

export default SlotCard;
